import { AbstractDestroyable } from '@deqo/foundation';
import { EventRouter, EventSource, Pod, SnapshotData } from '@deqo/podopolis';
import { invokeLater, uuid, waitFor } from '../../../CodesThatsGottaGoSomewhereElse';
import { ProfileData } from '../../../api/endpoints/me';
import { KioskActor } from './KioskActor';
import { KioskPod } from './KioskPod';
import { KioskUser } from './KioskUser';

class Recording extends AbstractDestroyable {

    public readonly data = [];
    private start = null;

    constructor(private outbound: EventSource<any>) {
        super();
        this.start = performance.now();
        this.burden(this.outbound.on('*', ([data], type) => {
            this.addSample(type, data);
        }));
    }

    private addSample(type: string, data: any) {
        this.data.push([performance.now() - this.start, type, data]);
    }
}

export class KioskController {

    private inbound = new EventRouter<any>();
    private outbound = new EventRouter<any>();
    private recording = null as Recording;
    private actors: KioskActor[] = [];

    private self = null as any;
    private time = 0;

    constructor(snapshot: SnapshotData, user: ProfileData) {
        this.time = snapshot.time;
        this.self = this.createProfile(user);


        this.outbound.on('subscribe_model', ([_, tag]) => {
            invokeLater(() => this.inbound.emit('acknowledge', [{}, tag]));
        });
        this.outbound.on('fetch_model', ([_, tag]) => {
            invokeLater(() => this.inbound.emit('reply_model', [snapshot, tag]));
        });
        this.outbound.on('fetch_register', ([_, tag]) => {
            invokeLater(() => this.inbound.emit('reply_register', [[[this.self.clientId, this.self]], tag]));
        });
        this.outbound.on('subscribe_topic', ([data, tag]) => {
            invokeLater(() => this.inbound.emit('notify_topic', [[...data, {}], tag]));
        });
        this.outbound.on('submit_tx', ([data, tag]) => {
            invokeLater(() => this.inbound.emit('reply_tx', [[true, ++this.time], tag]));
        });
    }

    public createPod(): Pod {
        return new KioskPod(this.self.clientId, this.inbound, this.outbound);
    }

    public startRecording() {
        this.recording = new Recording(this.outbound);
    }

    public stopRecording() {
        if (!this.recording) return [];
        try {
            return this.recording.data;
        }
        finally {
            this.recording.destroy();
            this.recording = null;
        }
    }

    public async getOrCreateActor(userId?: string) {

        const existingActor = this.actors.find(a => a.user.id === userId);
        if (existingActor) return existingActor;

        const user = KioskUser.create();
        const profile = {
            ...this.createProfile(user.id),
            px: 0,
            py: 0,
        };

        this.inbound.emit('notify_join', [[profile.clientId]]);
        this.inbound.emit('notify_profile', [[profile.clientId, Object.entries(profile), []]]);
        await waitFor(100);

        const newActor = new KioskActor(user, profile, this.inbound);
        this.actors.push(newActor);
        return newActor;
    }

    private createProfile(userId: any) {
        return {
            clientId: `${userId}/${uuid().slice(0, 8)}`,
            userId,
            sessionNumber: 0,
            sessionId: uuid().slice(8),
            track: true,
            createdAt: new Date(),
        };
    }
}
